import logger from '../log';
import { Binder } from '../player/bitmovin/interfaces';
import {
  BitmovinHttpRequest,
  BitmovinHttpRequestType,
  BitmovinSendHttpRequestMethod
} from '@kollective-frontend/ksdk-api';
import intercept from '../player/bitmovin/intercept';

const log = logger.getLogger(__filename);

// See: https://bitmovin.com/docs/player/api-reference/web/web-sdk-api-reference-v8#/player/web/8/docs/interfaces/core_network.networkconfig.html#sendhttprequest

export default function (binder: Binder): BitmovinSendHttpRequestMethod {
  return (type: BitmovinHttpRequestType, request: BitmovinHttpRequest) => {
    if (!binder.getOptions || !binder.shouldIntercept) {
      log.debug('sendHttpRequest called before binder set up');
      return undefined;
    }
    if (binder.shouldIntercept()) {
      const options = binder.getOptions() || {};
      return intercept({ options, type, request });
    }
    log.debug('Not using KollectiveXHR for request');
    return undefined;
  };
}
